module.exports = __webpack_public_path__ + "img/horizontal_7_7_9005.596e1dd9.png";